export const API_NAME = "CowinBE";
